import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import styles from "../../css/itgCtrl.module.css"

const TrafficTotalContext = createContext(null);

export function SwItsEmergVehTotalProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/integrated/GetEmergVeh");
            if (response.status === 200) {
                const data = response.data;

                setCurrentData({
                    updateTime: data.updateTime,
                    runValue: data.rows[0].runValue,
                    stopValue: data.rows[0].stopValue,
                    changeValue: data.diffPct.toFixed(2),
                    rangeValue: data.rows[0].rangeValue,
                    grnPerValue: data.rows[0].grnPerValue,
                    shortTimeValue: data.rows[0].shortTimeValue,
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}

export function SwItsEmergVehTotalInfo() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const date = new Date(currentData.updateTime);
    let hours = date.getHours() - 1;
    if (hours < 0) hours = 23;
    hours = String(hours).padStart(2, "0");

    const changeValueClass = parseFloat(currentData.changeValue) >= 0 ? 'plus' : 'minus';
    return (
        <div className='flx flx_col a_center' style={{ width: '100%', heigh: '100%' }}>
            <div className='flx a_flx_end'>
                <span className='subTxt' style={{ marginRight: '10px' }}>운행중</span>
                <span className='nbr'>{currentData.runValue?.toLocaleString()}</span>
                <span className='subTxt'>대</span>
                <span className='subTxt sls'>|</span>
                <span className='subTxt' style={{ marginRight: '10px' }}>완료</span>
                <span className='nbr'>{currentData.stopValue?.toLocaleString()}</span>
                <span className='subTxt'>대/일</span>
            </div>
            <div className='flx a_center j_center'>
                <span className="cmpr" style={{ marginRight: "10px" }}>
                    월 평균
                </span>
                <span className="cmpr" style={{ marginRight: "10px" }}>
                    {hours}시 대비
                </span>
                <span
                    className={`cmpr ${changeValueClass}`}
                    style={{ fontWeight: 'var(--ft-Bold)' }}
                >
                    {parseFloat(currentData.changeValue) >= 0 ? '+ ' : '- '}{Math.abs(currentData.changeValue)}
                </span>
                <span className='cmpr' style={{ marginLeft: '10px', }}>%</span>
            </div>
        </div>
    );
}

export function SwItsEmergVehTotalShorteningTime({ valueClass = 'L_d_i L_lr', detailClass = 'L_2m_20 innerBg flx flx_col a_center j_center' }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    return (
        <div className={valueClass}>
            <div className={`${detailClass} innerBg flx flx_col a_center j_center`} style={{ borderRadius: '32px' }}>
                <p className='subTit'>총 단축률</p>
                <div className='flx a_flx_end j_center'>
                    <span className='nbr'>{currentData.grnPerValue}</span>&nbsp;
                    <span className='subTxt' style={{ marginBottom: '14px', }}>%</span>
                </div>
            </div>
            <div className={`${detailClass} innerBg flx flx_col a_center j_center`} style={{ borderRadius: '32px' }}>
                <p className='subTit'>총 단축시간</p>
                <div className='flx a_flx_end j_center'>
                    <span className='nbr'>{currentData.stopValue?.toLocaleString()}</span>&nbsp;
                    <span className='subTxt' style={{ marginBottom: '14px', }}>회</span>
                    <span className='subTxt sls' style={{ marginBottom: '14px', }}>|</span>&nbsp;&nbsp;&nbsp;
                    <span className='nbr'>{currentData.shortTimeValue?.toLocaleString()}</span>&nbsp;
                    <span className='subTxt' style={{ marginBottom: '14px', }}>분</span>
                </div>
            </div>
        </div>
    )
}

// 통합관제 모듈에서 사용
export function SwItsEmergVehModuleTotalShorteningTime({ valueClass = 'L_d_i L_lr', detailClass = 'L_2m_20 innerBg flx flx_col a_center j_center' }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    return (
        <div className={valueClass}>
            <div className={`${detailClass} innerBg flx flx_col a_center j_center`} style={{ borderRadius: '32px' }}>
                <p className='subTit'>총 단축률</p>
                <div className='flx a_flx_end j_center'>
                    <span className='nbr'>{currentData.grnPerValue}</span>&nbsp;
                    <span className='subTxt' style={{ marginBottom: '14px', }}>%</span>
                </div>
            </div>
            <div className={`${detailClass} innerBg flx flx_col a_center j_center`} style={{ borderRadius: '32px' }}>
                <p className='subTit'>총 단축시간</p>
                <div className='flx a_flx_end j_center'>
                    <span className={`${styles.nbr_itg}`}>{currentData.stopValue?.toLocaleString()}</span>&nbsp;
                    <span className={`${styles.subTxt_itg}`}>회</span>
                    <span className={`${styles.sls_itg}`}>|</span>&nbsp;
                    <span className={`${styles.nbr_itg}`}>{currentData.shortTimeValue?.toLocaleString()}</span>&nbsp;
                    <span className={`${styles.subTxt_itg}`}>분</span>
                </div>
            </div>
        </div>
    )
}